import { Avenue, AvenueItem, AvenueProps } from '@common/components/Avenue';
import { Collection } from '@features/Collection';
import { CollectionCard } from '../cards/CollectionCard';
import { useTranslation } from 'react-i18next';

type CollectionItem = Collection & AvenueItem;

type CollectionAvenueProps = Omit<AvenueProps<CollectionItem>, 'renderItem'>;

export const CollectionAvenue = ({
    title,
    ...props
}: CollectionAvenueProps) => {
    const { t } = useTranslation('home');
    const renderCollectionItem = (collection: Collection): React.ReactNode => {
        return <CollectionCard collection={collection} />;
    };

    return (
        <Avenue<CollectionItem>
            {...props}
            title={t(title)}
            renderItem={renderCollectionItem}
        />
    );
};
